import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';

import { makeDefaultStylingContext } from '../tornado/utils/style';

const { screenSize, colorMode } = makeDefaultStylingContext();

export const WIDTH = {
  [HD]: 1280,
  [FULL_HD]: 1920,
};

export const OFFSET_TOP = {
  [HD]: 44,
  [FULL_HD]: 88,
};

export const OFFSET_RIGHT = {
  [HD]: 64,
  [FULL_HD]: 88,
};

export const CONTENT_HEIGHT = {
  [HD]: 48,
  [FULL_HD]: 56,
};

export const BUTTON_HEIGHT = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const BUTTON_MARGIN_LEFT = {
  [HD]: 56,
  [FULL_HD]: 72,
};

export const NAME_MARGIN_TOP = {
  [HD]: 16,
  [FULL_HD]: 18,
};

export const BUTTON_MARGING_RIGHT = {
  [HD]: 64,
  [FULL_HD]: 88,
};

export const NAME_MARGIN_LEFT = 16;
export const NAME_TEXT_COLOR = makeThemeColor(PRIMARY)[colorMode];
export const CONTENT_WIDTH = (WIDTH[screenSize] - OFFSET_RIGHT[screenSize]) / 2;

export const getInfoBarOffsetX = () => WIDTH[screenSize] - OFFSET_RIGHT[screenSize] - CONTENT_WIDTH;
export const getButtonPaddingTop = () => (CONTENT_HEIGHT[screenSize] - BUTTON_HEIGHT[screenSize]) / 2;

export const getInitialStyle = () => ({
  Content: {
    x: getInfoBarOffsetX(),
    y: OFFSET_TOP[screenSize],
    w: CONTENT_WIDTH,
    h: CONTENT_HEIGHT[screenSize],
    flex: { direction: 'row', wrap: true, justifyContent: 'flex-end', alignContent: 'center' },
    Avatar: {},
    Name: {
      flexItem: {
        marginLeft: NAME_MARGIN_LEFT,
        marginTop: NAME_MARGIN_TOP[screenSize],
      },
      text: {
        ...getFont(FONT.BERLIN_2, screenSize),
        textColor: NAME_TEXT_COLOR,
      },
    },
    ProfileChangeButton: {
      flexItem: {
        marginLeft: BUTTON_MARGIN_LEFT[screenSize],
        marginTop: getButtonPaddingTop(),
        marginRight: BUTTON_MARGING_RIGHT[screenSize],
      },
    },
  },
});
